import React, { useEffect, useState } from 'react';
import { Box, Preloader } from '@common-fe/common-fe';

import { DocumentPagePreview } from '@/components/elements/DropScan/dropScan.types';
import useConvertTiffToPng from '@/utils/hooks/useConvertTiffToPng';

import { useFileConvertToLMNStore } from '../../stores';
import { DocumentPreviewImage as RoundedImg } from '../DocumentPreviewImage';

interface Props {
  url?: string;
  alt?: string;
  isConvertMode?: boolean;
  onSetPreviews?: (previews: DocumentPagePreview[]) => void;
  isFixedDocumentSize?: boolean;
}

const TiffScanViewer: React.FC<Props> = ({ isConvertMode, url, alt, onSetPreviews, isFixedDocumentSize }) => {
  const { pngDocuments, isLoading } = useConvertTiffToPng({ url });
  const [previews, setPreviews] = useState<DocumentPagePreview[]>([]);
  const selectedIds = useFileConvertToLMNStore((state) => state.selectIndexes);
  useEffect(() => {
    if (pngDocuments?.length) {
      let newPreviews = pngDocuments.map(
        (pngDocument): DocumentPagePreview => ({
          ...pngDocument,
          pageRef: React.createRef<HTMLDivElement>(),
        })
      );

      setPreviews(newPreviews);

      if (onSetPreviews) {
        if (isConvertMode) {
          newPreviews = newPreviews.filter((item, index) => selectedIds.includes(index));
        }
        onSetPreviews(newPreviews);
      }
    }
  }, [pngDocuments, onSetPreviews, isConvertMode, selectedIds]);

  if (isLoading) {
    return (
      <Box height="60px" justify="center" align="center">
        <Preloader testId="tiff-document-preloader" />
      </Box>
    );
  }
  if (isConvertMode) {
    return (
      <Box height={{ min: 'auto' }}>
        {previews.map((pngDocument, index) => (
          <Box
            key={pngDocument?.id}
            ref={pngDocument.pageRef}
            margin={{ top: 'spacing12' }}
            style={{ display: selectedIds.includes(index) ? 'block' : 'none' }}
          >
            <RoundedImg src={pngDocument?.link} alt={alt} $isFixedSize={isFixedDocumentSize} />
          </Box>
        ))}
      </Box>
    );
  }
  return (
    <Box height={{ min: 'auto' }}>
      {previews.map((pngDocument) => (
        <Box key={pngDocument?.id} ref={pngDocument.pageRef} margin={{ top: 'spacing12' }}>
          <RoundedImg src={pngDocument?.link} alt={alt} $isFixedSize={isFixedDocumentSize} />
        </Box>
      ))}
    </Box>
  );
};

export default TiffScanViewer;
